import classNames from "classnames";
import { ReactNode } from "react";

type ColProps = {
    size?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    xs?: number;
    xxl?: number;
    children?: ReactNode;
    className?: string;
}

/*
basis-1/12 basis-2/12 basis-3/12 basis-4/12 basis-5/12 basis-6/12 
basis-7/12 basis-8/12 basis-9/12 basis-10/12 basis-11/12
sm:basis-1/12 sm:basis-2/12 sm:basis-3/12 sm:basis-4/12 sm:basis-5/12 sm:basis-6/12 
sm:basis-7/12 sm:basis-8/12 sm:basis-9/12 sm:basis-10/12 sm:basis-11/12
md:basis-1/12 md:basis-2/12 md:basis-3/12 md:basis-4/12 md:basis-5/12 md:basis-6/12 
md:basis-7/12 md:basis-8/12 md:basis-9/12 md:basis-10/12 md:basis-11/12
lg:basis-1/12 lg:basis-2/12 lg:basis-3/12 lg:basis-4/12 lg:basis-5/12 lg:basis-6/12 
lg:basis-7/12 lg:basis-8/12 lg:basis-9/12 lg:basis-10/12 lg:basis-11/12
xl:basis-1/12 xl:basis-2/12 xl:basis-3/12 xl:basis-4/12 xl:basis-5/12 xl:basis-6/12 
xl:basis-7/12 xl:basis-8/12 xl:basis-9/12 xl:basis-10/12 xl:basis-11/12
2xl:basis-1/12 2xl:basis-2/12 2xl:basis-3/12 2xl:basis-4/12 2xl:basis-5/12 2xl:basis-6/12 
2xl:basis-7/12 2xl:basis-8/12 2xl:basis-9/12 2xl:basis-10/12 2xl:basis-11/12
*/

export const Col = ({...props}: ColProps) => {
  
  const className = classNames({
    'grow-0': true,
    'pr-3 last:pr-0': true,
    'mb-4': true,
    'basis-full': (props.size && !props.sm && props.size === 12) || props.xs === 12 || props.md === 12 || props.lg === 12 || props.xl === 12 || props.xxl === 12,
    [`basis-${props.size}/12`]: props.size && !props.sm && props.size < 12,
    [`sm:basis-${props.sm}/12`]: props.sm,
    [`md:basis-${props.md}/12`]: props.md,
    [`lg:basis-${props.lg}/12`]: props.lg,
    [`xl:basis-${props.xl}/12`]: props.xl,
    [`2xl:basis-${props.xxl}/12`]: props.xxl,
    [`${props.className}`]: true
  });

  return (
    <div className={className}>
        {props.children}
    </div>
  )
}